import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AddIcon60 = (props: SvgProps) => (
  <Svg
    width={65}
    height={64}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M51.165 24v29.333A2.667 2.667 0 0 1 48.5 56h-32a2.667 2.667 0 0 1-2.667-2.667V10.667A2.667 2.667 0 0 1 16.499 8h18.666m16 16-16-16m16 16h-16V8M32.5 35v10m-5-5h10"
    />
  </Svg>
);
export default AddIcon60;
